module.exports = __webpack_public_path__ + "static/phone-slide-4-4c0b776352269fddb26c272a5913806c.png";